import { Button, Stack, styled } from '@mui/material';
import { FilterIcon, Spin } from '@schooly/style';
import { FC, PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';

type FiltersContainerProps = PropsWithChildren<{
  isFetching?: boolean;
  onOpenFilters?: () => void;
}>;
export const FiltersContainer: FC<FiltersContainerProps> = ({
  children,
  onOpenFilters,
  isFetching,
}) => {
  const { formatMessage } = useIntl();

  return (
    <FiltersContainerStyled data-test-id={'filters'}>
      {children}
      {onOpenFilters && (
        <Button
          size="small"
          variant="outlined"
          onClick={onOpenFilters}
          data-test-id={'filters-open'}
          startIcon={isFetching ? <Spin /> : <FilterIcon />}
        >
          {formatMessage({ id: 'filter-Filters' })}
        </Button>
      )}
    </FiltersContainerStyled>
  );
};

export const FiltersContainerStyled = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  flex: 1,
  columnGap: theme.spacing(2),
  rowGap: theme.spacing(1),
  lineHeight: theme.spacing(3.75),
  alignItems: 'center',
  flexWrap: 'wrap',
}));
